import type { FaireProductEntity } from "../../entity_types/product";

export const p_ahan4g43h4: FaireProductEntity = {
  token: "p_ahan4g43h4",
  type: "product",
  name: "Zen Again Cortisol Manager",
  brandToken: "b_czxv7ugga8",
  brandName: "Happy Healthy Hippie",
  imageUrl:
    "https://cdn.faire.com/fastly/0f9d17ab507da4a65334820ad86e9074fed4cebe07693d222746640036d500e2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0ff7e2523387e4cc8680ffde4886643b8a30ef02a499aabb78a0d0d45275d27.jpeg",
    "https://cdn.faire.com/fastly/790448ba2ea30666dd64f7fbd2a3061c8a2785a738394c0f80cd5d0796f40f69.jpeg",
    "https://cdn.faire.com/fastly/f2bfe9b89a67d8630d09d0cdaa74438fd5d1fddbc935fb595c170f781e5d1cb8.jpeg",
    "https://cdn.faire.com/fastly/94fb92c7c4c096212d7c36ddc484264dfdd6fc22135c982577d7b51771c224b1.jpeg",
    "https://cdn.faire.com/fastly/c6422315f2a8febc5f6a50f044bd70795ad98ccfa1e2e0b89867ef0b30a4dac0.jpeg",
    "https://cdn.faire.com/fastly/311adfe26c50d4bb3d52e969719c42f0fc9176c09db6184409c87b5e660ba6d8.jpeg",
  ],
  priceDollars: 13.99,
  description:
    "Zen Again Cortisol Manager is a 100% plant-based supplement that supports you by:\n\n * Balances cortisol levels with help from KSM-66® Ashwagandha \n * Supports your body's natural stress response with adaptogens \n * Helps improve your quality of sleep \n * Aids in daily mood support \n\nTry it risk free with our 60-Day Money Back Guarantee.\n",
  tags: [],
  msrpDollars: 27.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:01.393Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
